module.exports = __webpack_public_path__ + "static/img/wow.8c87474b.png";